import React from 'react';

const UsageTable = ({ data, isAdmin = false }) => (
  <div className="bg-white rounded-xl shadow-sm overflow-hidden">
    <div className="p-6 border-b">
      <h2 className="text-lg font-semibold">Usage History</h2>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-gray-50">
          <tr>
            {isAdmin && <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">User</th>}
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Operation</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Tokens Used</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cost</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {data.map((item, index) => (
            <tr key={index} className="hover:bg-gray-50">
              {isAdmin && (
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600">
                      {item.userName?.[0]}
                    </div>
                    <div className="ml-3">
                      <p className="text-sm font-medium">{item.userName}</p>
                      <p className="text-xs text-gray-500">{item.userEmail}</p>
                    </div>
                  </div>
                </td>
              )}
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800">
                  {item.operationType}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                {item.tokens.toLocaleString()}
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                ${item.cost.toFixed(4)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {new Date(item.timestamp).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default UsageTable;